import React, { useState, useEffect } from "react";

const AccountInfo = ({ UserDetails }) => {
  const [showContent, setShowContent] = useState(false);
  const [time, setTime] = useState("");

  const toggleContent = () => setShowContent(!showContent);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      setTime(now.toLocaleTimeString());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="bg-dark text-center position-fixed bottom-0 end-0 start-0 w-100 m-0 p-0"
      style={{ zIndex: 999 }}
    >
      {showContent && (
        <div id="myDiv" className="text-light">
          <ul
            className="nav nav-tabs mb-3 border border-secondary"
            id="ex1"
            role="tablist"
            style={{ backgroundColor: "#121212" }}
          >
            <li className="nav-item" role="presentation">
              <a
                className="nav-link active text-light"
                id="ex1-tab-1"
                data-bs-toggle="tab"
                href="#ex1-tabs-1"
                role="tab"
                aria-controls="ex1-tabs-1"
                aria-selected="true"
                style={{ backgroundColor: "#1e1e1e" }}
              >
                Account Message
                <i className="ps-2 fa-solid fa-message"></i>
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link text-light"
                id="ex1-tab-2"
                data-bs-toggle="tab"
                href="#ex1-tabs-2"
                role="tab"
                aria-controls="ex1-tabs-2"
                aria-selected="false"
                style={{ backgroundColor: "#1e1e1e" }}
              >
                Account Manifest
                <i className="ps-2 fa-solid fa-square-check"></i>
              </a>
            </li>
          </ul>

          <div
            className="tab-content m-3"
            id="ex1-content"
            style={{ backgroundColor: "#1a1a1a", borderRadius: "6px" }}
          >
            <div
              className="tab-pane fade show active"
              id="ex1-tabs-1"
              role="tabpanel"
              aria-labelledby="ex1-tab-1"
            >
              <div className="card p-2 bg-dark text-light border-secondary">
                <p>
                  {UserDetails.message === ""
                    ? "No account message yet"
                    : UserDetails.message}
                </p>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="ex1-tabs-2"
              role="tabpanel"
              aria-labelledby="ex1-tab-2"
            >
              <div className="card p-2 bg-dark text-light border-secondary">
                <h5>TRADE ACCOUNT MANIFEST</h5>
                <div className="row" id="amani">
                  <div className="border p-3 border-secondary rounded mb-3">
                    <p>
                      SIGNAL-STRENGTH{" "}
                      <i className="fa-solid fa-flag text-success"></i>
                    </p>
                    <div className="progress" style={{ height: "20px" }}>
                      <div
                        className="fs-5 progress-bar progress-bar-striped progress-bar-animated bg-success"
                        role="progressbar"
                        aria-valuenow={UserDetails.signals}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{
                          height: "20px",
                          width: `${UserDetails.signals}%`,
                        }}
                      >
                        {UserDetails.signals}%
                      </div>
                    </div>
                  </div>
                  <div className="border p-3 border-secondary rounded">
                    <p className="m-0 p-0">
                      MAINTENANCE GAUGE{" "}
                      <i className="fa-solid fa-flag text-success"></i>
                    </p>
                    <div className="progress" style={{ height: "20px" }}>
                      <div
                        className="fs-5 progress-bar progress-bar-striped progress-bar-animated bg-success"
                        role="progressbar"
                        aria-valuenow={UserDetails.maintenance}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{
                          height: "20px",
                          width: `${UserDetails.maintenance}%`,
                        }}
                      >
                        {UserDetails.maintenance}%
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div>
        <div className="row border m-0 p-0 border-secondary">
          <div
            className="col-md-4 rounded-2 btn btn-sm"
            id="toggleButton"
            style={{ backgroundColor: "#0e121b", paddingTop: "1px" }}
            onClick={toggleContent}
          >
            <div className="m-0 p-0">
              <div
                className="d-flex justify-content-start m-0 p-0"
                style={{ marginLeft: "10px" }}
              >
                <p
                  className="fw-bold m-0 p-0"
                  style={{ fontSize: "11px", cursor: "pointer", color: "#ccc" }}
                >
                  Auto Trade:{" "}
                  {UserDetails.autotrade === "ACTIVE" ? (
                    <>
                      <span className="text-success"> Active</span>
                      <i className="ps-2 fa-solid fa-check"></i>
                    </>
                  ) : (
                    <>
                      <span className="text-danger"> Inactive</span>
                      <i className="ps-2 fa-solid fa-cancel"></i>
                    </>
                  )}
                </p>
                <p className="m-0 p-0" style={{ color: "#ccc", fontSize:'11px' }}>
                  <strong className="ms-4 p-0 m-0">{UserDetails.billing}</strong>{" "}
                  <strong className="text-warning ps-2">
                    ${UserDetails.billing_amount}
                  </strong>
                </p>
                <span className="px-3 py-0 bg-success rounded-1 ms-md-5 ms-2 fw-bold" style={{fontSize: "12px",}}>
                  Account Info
                </span>
              </div>
            </div>
          </div>

          <div className="col-md-8 d-flex justify-content-md-start justify-content-center bg-dark pt-1">
            <p
              id="time"
              className="p-0 m-0"
              style={{
                fontWeight: "bold",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontSize: "10px",
                color: "#ccc",
              }}
            >
              {time}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountInfo;